
import axios from 'axios';

// Fetch all navigation items
export function fetchAll() {
  return axios.get('/api/SiteNavigation');
}
